module.exports = __webpack_public_path__ + "_assets/img/people.3bd5e041.svg";